import styled from 'styled-components';
import colors from '../../theme/search/colors';

const Wrapper = styled.div`
  .tags-container {
    padding-top: 28px;
    margin-bottom: 23px;
    margin-left: 17px;
    margin-right: 17px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    > .tag {
      cursor: pointer;
      margin-right: 6px;
      margin-bottom: 10px;
      display: inline-block;
      padding-top: 4px;
      padding-bottom: 4px;
      padding-left: 8px;
      padding-right: 8px;
      border: 1px solid ${colors.lightGrey};
      border-radius: 3px;
      background-color: #ffffff;
      font-size: 15px;
      line-height: 18px;
      color: ${colors.darkGray};

      > .tag-container {
        display: flex;
        align-items: center;
        justify-content: space-between;

        > .icon-close {
          margin-left: 8px;
        }
      }
    }
  }

  .remove-filters-container {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 23px;
  }
`;

const svgStyle = {
  width: 10
};

export { Wrapper, svgStyle };



// WEBPACK FOOTER //
// ./src/components/FacetFilter/style.js